// extracted by mini-css-extract-plugin
export var animationContainer = "_is-0";
export var asteriskIcon = "_is-8";
export var conversationLeftSection = "_is-4";
export var conversationListItem = "_is-3";
export var conversationMiddleSection = "_is-5";
export var conversationRightSection = "_is-6";
export var detailsContent = "_is-1";
export var listContainer = "_is-7";
export var modalContent = "_is-2";